/* eslint-disable */
import L from "leaflet";
import "leaflet.awesome-markers";

// Extend Leaflet's Icon class with custom functionality
L.AwesomeMarkers.IconCustom = L.AwesomeMarkers.Icon.extend({
  options: {
    html: ""
  },

  createIcon: function() {
    var div = document.createElement("div"),
      options = this.options;

    div.innerHTML = this._createInner();

    if (options.bgPos) {
      div.style.backgroundPosition =
        -options.bgPos.x + "px " + -options.bgPos.y + "px";
    }

    this._setIconStyles(div, "icon-" + options.markerColor);
    return div;
  },

  _createInner: function() {
    var iconClass,
      iconSpinClass = "",
      iconColorClass = "",
      iconStyle = "",
      options = this.options;

    if (
      options.icon.slice(0, options.prefix.length + 1) ===
      options.prefix + "-"
    ) {
      iconClass = options.icon;
    } else {
      iconClass = options.prefix + "-" + options.icon;
    }

    if (options.spin && typeof options.spinClass === "string") {
      iconSpinClass = options.spinClass;
    }

    if (options.iconColor) {
      if (options.iconColor === "white" || options.iconColor === "black") {
        iconColorClass = "icon-" + options.iconColor;
        iconStyle = "style='" + options.iconStyle + "' ";
      } else {
        iconStyle =
          "style='color: " + options.iconColor + ";" + options.iconStyle + "' ";
      }
    }

    return (
      "<i " +
      iconStyle +
      "class='" +
      options.extraClasses +
      " " +
      options.prefix +
      " " +
      iconClass +
      " " +
      iconSpinClass +
      " " +
      iconColorClass +
      "'>" +
      options.html +
      "</i>"
    );
  }
});

L.AwesomeMarkers.iconCustom = function(options) {
  return new L.AwesomeMarkers.IconCustom(options);
};

export default L.AwesomeMarkers.iconCustom;
